import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { VehicleIndicatorTypeNamePipe } from './vehicle-indicator-type-name.pipe';
import { VehicleIndicatorTypeUnitPipe } from './vehicle-indicator-type-unit.pipe';
import { TimeFormatPipe } from './time-format.pipe';
import { FullAddressPipe } from './full-address.pipe';
import { DriverFullNamePipe } from './driver-full-name.pipe';
import { DateLabelPipe } from './date-label.pipe';
import { StatusTimeFormatPipe } from './status-time-format.pipe';
import { EmptytPipe } from './empty.pipe';
import { HoursTimeFormatPipe } from './hours-time-format.pipe';
import { CorrectUrlPipe } from './correct-url.pipe';
import { PrepareTimePipe } from './prepare-time.pipe';
import { TranslateByTextPipe } from './translate-by-text.pipe';
import { AreaTypeImgPipe } from './area-type-img.pipe';
import { FilterArrByPropValuePipe } from './filter-arr-by-prop-value.pipe';
import { FormatSecondsToHumanizePipe } from './format-seconds-to-humanize.pipe';
import { FilterTachoListPipe } from './filter-tacho-list.pipe';
import { TimeDifferencePipe } from './time-difference.pipe';
import { DistancePipe } from './distance.pipe';
import { FuelPipe } from './fuel.pipe';

@NgModule({
	imports: [
		CommonModule,
	],
	declarations: [
		VehicleIndicatorTypeNamePipe,
		VehicleIndicatorTypeUnitPipe,
		TimeFormatPipe,
		FullAddressPipe,
		DriverFullNamePipe,
		DateLabelPipe,
		StatusTimeFormatPipe,
		EmptytPipe,
		HoursTimeFormatPipe,
		CorrectUrlPipe,
		PrepareTimePipe,
  		TranslateByTextPipe,
		AreaTypeImgPipe,
		FilterArrByPropValuePipe,
		FormatSecondsToHumanizePipe,
		FilterTachoListPipe,
  		TimeDifferencePipe,
		DistancePipe,
		FuelPipe,
	],
	exports: [
		VehicleIndicatorTypeNamePipe,
		VehicleIndicatorTypeUnitPipe,
		TimeFormatPipe,
		FullAddressPipe,
		DriverFullNamePipe,
		DateLabelPipe,
		StatusTimeFormatPipe,
		EmptytPipe,
		HoursTimeFormatPipe,
		CorrectUrlPipe,
		PrepareTimePipe,
		TranslateByTextPipe,
		AreaTypeImgPipe,
		FilterArrByPropValuePipe,
		FormatSecondsToHumanizePipe,
		FilterTachoListPipe,
		TimeDifferencePipe,
		DistancePipe,
		FuelPipe,
	],
	providers: [
	],

})
export class PipesModule { }
